var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page close-picker" }, [
    _c("div", { staticClass: "page-content" }, [
      _c(
        "div",
        { staticClass: "listPage" },
        [
          _c("div", { staticClass: "layoutTop" }),
          _vm._v(" "),
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "10", "offset-md": "1" } },
                    [
                      _c("back-button", {
                        attrs: { returnUrl: "/attachments/" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "panel21 panel-default" },
                        [
                          _c("div", { staticClass: "panel-heading" }, [
                            _c(
                              "h4",
                              {
                                staticClass: "content-block labelAccordionForm",
                              },
                              [
                                _c("img", {
                                  staticClass: "formIcon formIconSmall",
                                  attrs: {
                                    src: require("../../assets/static/images/icons/paperclip.png"),
                                  },
                                }),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("attachments.create_invoice")
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                title: _vm.$t("common.formsSubTitle.gnrl"),
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputType: "date",
                                          inputLabel: _vm.$t(
                                            "attachments.dlvry_date"
                                          ),
                                          placeholderValue: _vm.$t(
                                            "common.placeholder_format_date"
                                          ),
                                        },
                                        model: {
                                          value: _vm.dateOfIssue,
                                          callback: function ($$v) {
                                            _vm.dateOfIssue = $$v
                                          },
                                          expression: "dateOfIssue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputLabel:
                                            _vm.createInvoice_Reference,
                                          placeholderValue:
                                            _vm.createInvoice_Reference,
                                        },
                                        model: {
                                          value: _vm.identifier,
                                          callback: function ($$v) {
                                            _vm.identifier = $$v
                                          },
                                          expression: "identifier",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "6" } },
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputType: "date",
                                          inputLabel:
                                            _vm.createInvoice_Selectadate,
                                          placeholderValue:
                                            _vm.createInvoice_Selectadate,
                                        },
                                        model: {
                                          value: _vm.dateOfSale,
                                          callback: function ($$v) {
                                            _vm.dateOfSale = $$v
                                          },
                                          expression: "dateOfSale",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                title: _vm.$t("common.formsSubTitle.rcpt"),
                              },
                            },
                            [
                              _c(
                                "b-row",
                                {
                                  staticClass: "form-group",
                                  class: _vm.colorBottomButton,
                                },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "createInvoicePicker",
                                      attrs: { sm: "4" },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "link open-picker button button-round",
                                          attrs: {
                                            href: "#",
                                            "data-picker": ".contactListPicker",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t("common.slct_ctcts")
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputLabel:
                                            _vm.createInvoice_FullName,
                                          placeholderValue:
                                            _vm.createInvoice_FullName,
                                        },
                                        model: {
                                          value: _vm.debtorName,
                                          callback: function ($$v) {
                                            _vm.debtorName = $$v
                                          },
                                          expression: "debtorName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.createInvoice_Address,
                                          placeholderValue:
                                            _vm.createInvoice_Address,
                                        },
                                        model: {
                                          value: _vm.debtorAddress,
                                          callback: function ($$v) {
                                            _vm.debtorAddress = $$v
                                          },
                                          expression: "debtorAddress",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.createInvoice_City,
                                          placeholderValue:
                                            _vm.createInvoice_City,
                                        },
                                        model: {
                                          value: _vm.debtorCodeAddress,
                                          callback: function ($$v) {
                                            _vm.debtorCodeAddress = $$v
                                          },
                                          expression: "debtorCodeAddress",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.createInvoice_Zipcode,
                                          placeholderValue:
                                            _vm.createInvoice_Zipcode,
                                        },
                                        model: {
                                          value: _vm.debtorZipCode,
                                          callback: function ($$v) {
                                            _vm.debtorZipCode = $$v
                                          },
                                          expression: "debtorZipCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "6" } },
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.createInvoice_Country,
                                          placeholderValue:
                                            _vm.createInvoice_Country,
                                        },
                                        model: {
                                          value: _vm.debtorCountry,
                                          callback: function ($$v) {
                                            _vm.debtorCountry = $$v
                                          },
                                          expression: "debtorCountry",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                title: _vm.$t("common.formsSubTitle.sndr"),
                              },
                            },
                            [
                              _c(
                                "b-row",
                                { staticClass: "form-group" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputLabel:
                                            _vm.createInvoice_Identifier,
                                        },
                                        model: {
                                          value: _vm.creditorIdentifier,
                                          callback: function ($$v) {
                                            _vm.creditorIdentifier = $$v
                                          },
                                          expression: "creditorIdentifier",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          inputLabel:
                                            _vm.createInvoice_Registrynumber,
                                          placeholderValue:
                                            _vm.createInvoice_Registrynumber,
                                        },
                                        model: {
                                          value: _vm.rcs,
                                          callback: function ($$v) {
                                            _vm.rcs = $$v
                                          },
                                          expression: "rcs",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          inputLabel:
                                            _vm.createInvoice_TVAnumber,
                                          placeholderValue:
                                            _vm.createInvoice_TVAnumber,
                                        },
                                        model: {
                                          value: _vm.identifierTVA,
                                          callback: function ($$v) {
                                            _vm.identifierTVA = $$v
                                          },
                                          expression: "identifierTVA",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputLabel: _vm.createInvoice_Address,
                                          placeholderValue:
                                            _vm.createInvoice_Address,
                                        },
                                        model: {
                                          value: _vm.creditorAddress,
                                          callback: function ($$v) {
                                            _vm.creditorAddress = $$v
                                          },
                                          expression: "creditorAddress",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputLabel: _vm.createInvoice_City,
                                          placeholderValue:
                                            _vm.createInvoice_City,
                                        },
                                        model: {
                                          value: _vm.creditorCodeAddress,
                                          callback: function ($$v) {
                                            _vm.creditorCodeAddress = $$v
                                          },
                                          expression: "creditorCodeAddress",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputLabel: _vm.createInvoice_Zipcode,
                                          placeholderValue:
                                            _vm.createInvoice_Zipcode,
                                        },
                                        model: {
                                          value: _vm.creditorZipCode,
                                          callback: function ($$v) {
                                            _vm.creditorZipCode = $$v
                                          },
                                          expression: "creditorZipCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputLabel: _vm.createInvoice_Country,
                                          placeholderValue:
                                            _vm.createInvoice_Country,
                                        },
                                        model: {
                                          value: _vm.creditorCountry,
                                          callback: function ($$v) {
                                            _vm.creditorCountry = $$v
                                          },
                                          expression: "creditorCountry",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          inputLabel:
                                            _vm.createInvoice_LegalForm,
                                          placeholderValue:
                                            _vm.createInvoice_LegalForm,
                                        },
                                        model: {
                                          value: _vm.legalForm,
                                          callback: function ($$v) {
                                            _vm.legalForm = $$v
                                          },
                                          expression: "legalForm",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "6" } },
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          inputType: "number",
                                          inputLabel:
                                            _vm.$t("common.shr_cptl") + " (€)",
                                          placeholderValue:
                                            _vm.createInvoice_amount,
                                        },
                                        model: {
                                          value: _vm.amountOfCapital,
                                          callback: function ($$v) {
                                            _vm.amountOfCapital = $$v
                                          },
                                          expression: "amountOfCapital",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "colorBottomButton",
                                      attrs: { cols: "5", sm: "2" },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "inputFileButton attachementCreateInvoiceButtonLength",
                                          staticStyle: { width: "90%" },
                                          attrs: { for: "fileLogo" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(_vm.$t("common.lgo")) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    staticClass: "inputfile",
                                    attrs: {
                                      type: "file",
                                      name: "fileLogo",
                                      id: "fileLogo",
                                    },
                                    on: { change: _vm.onFileChange },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "7", sm: "10" } },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.logoName,
                                            expression: "logoName",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          name: "filename",
                                          placeholder:
                                            _vm.createInvoice_Choosefile,
                                          type: "text",
                                          disabled: "",
                                        },
                                        domProps: { value: _vm.logoName },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.logoName = $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                title: _vm.$t("common.formsSubTitle.srvc"),
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputLabel: _vm.createInvoice_Reason,
                                          placeholderValue:
                                            _vm.createInvoice_Reason,
                                        },
                                        model: {
                                          value: _vm.remittanceInformation,
                                          callback: function ($$v) {
                                            _vm.remittanceInformation = $$v
                                          },
                                          expression: "remittanceInformation",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputType: "number",
                                          inputLabel:
                                            _vm.createInvoice_Pretaxamount,
                                          placeholderValue:
                                            _vm.createInvoice_Pretaxamount,
                                        },
                                        model: {
                                          value: _vm.amountHT,
                                          callback: function ($$v) {
                                            _vm.amountHT = $$v
                                          },
                                          expression: "amountHT",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "6" } },
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputType: "number",
                                          inputLabel: _vm.createInvoice_VAT,
                                          placeholderValue:
                                            _vm.createInvoice_VAT,
                                        },
                                        model: {
                                          value: _vm.percentTVA,
                                          callback: function ($$v) {
                                            _vm.percentTVA = $$v
                                          },
                                          expression: "percentTVA",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                title: _vm.$t("common.formsSubTitle.othr"),
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "6" } },
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          inputType: "date",
                                          inputLabel: _vm.$t(
                                            "common.pymnts_dates"
                                          ),
                                          placeholderValue: _vm.$t(
                                            "common.datepicker_format_date"
                                          ),
                                        },
                                        model: {
                                          value: _vm.paymentsDate,
                                          callback: function ($$v) {
                                            _vm.paymentsDate = $$v
                                          },
                                          expression: "paymentsDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "picker-modal contactListPicker" },
                            [
                              _c("div", { staticClass: "toolbar" }, [
                                _c("div", { staticClass: "toolbar-inner" }, [
                                  _c("div", { staticClass: "left" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "right" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "close-picker",
                                        attrs: { href: "#" },
                                        on: {
                                          click:
                                            _vm.contactListPickerCloseButton,
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("common.dne")))]
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "picker-modal-inner scrollablePicker",
                                },
                                [
                                  _c(
                                    "form",
                                    {
                                      staticClass: "searchbar searchbar-init",
                                      attrs: {
                                        "data-search-list":
                                          ".contactRecipientList",
                                        "data-search-in": ".item-title",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "searchbar-input" },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "search",
                                              placeholder:
                                                _vm.createInvoice_Search,
                                            },
                                          }),
                                          _c("a", {
                                            staticClass: "searchbar-clear",
                                            attrs: { href: "#" },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "searchbar-cancel",
                                          attrs: { href: "#" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(_vm.$t("common.cncl")) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "list-block contactRecipientList",
                                    },
                                    [
                                      _c(
                                        "f7-list",
                                        {
                                          staticClass: "contactRecipientList",
                                          attrs: { contacts: "" },
                                        },
                                        _vm._l(
                                          this.contactSelectionList,
                                          function (group, key) {
                                            return _c(
                                              "f7-list-group",
                                              { key: key },
                                              [
                                                _c("f7-list-item", {
                                                  attrs: {
                                                    title: key,
                                                    "group-title": "",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _vm._l(
                                                  group,
                                                  function (contact) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        attrs: {
                                                          value: contact.id,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "label-radio item-content",
                                                            on: {
                                                              click:
                                                                _vm.contactListPickerCloseButton,
                                                            },
                                                          },
                                                          [
                                                            _c("input", {
                                                              attrs: {
                                                                type: "radio",
                                                                name: "countryPickerRadio",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  contact.id,
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-inner",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "item-title",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        contact.name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { md: "2", "offset-md": "9" } }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "milkyBlockBlack button-action firstButtonMarginTop",
                        attrs: { round: "" },
                        on: {
                          click: function ($event) {
                            return _vm.createInvoice("cloud")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "icon fa fa-save" }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-row", [_c("div", { staticClass: "toolbarPageBottomBlank" })]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }